import React, { createContext, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { VtsInterface } from '../../Interface/Vts';
import { getRequest } from '../Helper/ApiClient';

export const VtsContext = createContext<{
  vts: VtsInterface | undefined;
}>({
  vts: undefined,
});

const VtsProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const hasStatusParam = searchParams.has('status');
  const vtsRequest = getRequest<VtsInterface>(`/api/onlineshop/vts${hasStatusParam ? `?status=${searchParams.get('status')}` : ``}`);

  return (
    <VtsContext.Provider value={{ vts: vtsRequest.data }}>
      {children}
    </VtsContext.Provider>
  );
};

export function useVts() {
  const context = useContext(VtsContext);
  if (!context) {
    throw new Error('useProductList must be used within ProductListProvider');
  }
  return context;
}

export default VtsProvider;
